<div class="team-wrap d-flex align-items-center">
  <!-- <img [src]="top_competitor.image" class="img"/> -->
  <div class="pic-wrap">
    <img
      *ngIf="
        top_competitor.image !== null &&
        top_competitor.image !== undefined &&
        top_competitor.image !== ''
      "
      src="{{ top_competitor.image }}"
      class="img"
    />
    <span *ngIf="top_competitor.image == null" class="vname">{{
      top_competitor.name | initials
    }}</span>
  </div>
  <div class="wrap-textright">
    <span class="title-text">{{ top_competitor.name | name }}</span>
    <span class="type-text">{{ top_competitor.c_cin }}</span>
    <!-- <a href="/" class="link-btn">Add to Compare +</a> -->
  </div>
</div>
